import { render } from "./ApplicationMark.vue?vue&type=template&id=f875d33a"
const script = {}

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__